import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { AiFillCloseCircle } from "react-icons/ai";
import axios from "axios";
import toast from "react-hot-toast";
const CreateBooking = ({ bookingModal, setBookingModal }) => {
  const [load, setLoad] = useState(false);
  const [building, setBuilding] = useState([]);
  const [floor, setFloor] = useState([]);
  const [floorNumber, setFloorNumber] = useState(0);
  const [rooms, setRooms] = useState([]);
  const [buildingId, setBuildingId] = useState("");
  const [bed, setBed] = useState([]);
  const [currentRoom, setCurrentRoom] = useState({});
  const [bedValue, setBedValue] = useState("");
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    console.log(data);
    setLoad(true);
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/booking/register_booking`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data);
        toast.success(response.data.message);
        setBookingModal(false);
        setLoad(false);
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.response.data.message);
        setLoad(false);
      });
  };

  const fetchAllBuildings = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/resources/get_all_building`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("fhghgjgj---->", response.data.data);
        setBuilding(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getFloors = (id) => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/resources/get_floors_by_building/${id}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("i am floor--->", response.data);
        setFloor(response.data.data.floorDetails);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getConfiguredRoomByBuilding = (floorNumber) => {
    console.log("------>", floorNumber, buildingId);

    setFloorNumber(floorNumber);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/rooms/get_configured_room_by_building/${buildingId}/${floorNumber}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("i am floor--->", response.data);
        setRooms(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleBed = (id) => {
    const myData = {
      roomId: id,
    };

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/beds/get-beds-by-room-id`,

      headers: {
        "Content-Type": "application/json",
      },
      data: myData,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("----beds array-->", response.data.data);
        setBed(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchAllBuildings();
  }, []);
  return (
    <div className=" bg-black/50    backdrop-blur-sm fixed inset-0 w-full z-50 flex items-center justify-center min-h-screen">
      <div className="relative h-[30rem] md:h-auto overflow-y-scroll md:overflow-y-hidden bg-white p-8 lg:py-8 lg:px-16 rounded-lg shadow-lg w-full max-w-5xl">
        <div className="mb-6">
          <h2 className="text-2xl font-semibold text-center">
            Add New Booking
          </h2>
          <AiFillCloseCircle
            onClick={() => setBookingModal(false)}
            className="cursor-pointer text-primaryColor absolute top-4 right-4"
            size={30}
          />
        </div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div className="col-span-1">
              <label className="block text-sm font-medium text-primaryTextColor">
                Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter Name"
                className={`mt-1 block w-full border ${
                  errors.name ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                {...register("name", { required: true })}
              />
            </div>
            <div className="col-span-1">
              <label className="block text-sm font-medium text-primaryTextColor">
                Mob Number <span className="text-red-500">*</span>
              </label>
              <input
                type="number"
                placeholder="Mobile Number"
                maxLength={10}
                className={`mt-1 block w-full border ${
                  errors.mobileNumber ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                {...register("mobileNumber", {
                  required: true,
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: "Mobile number must be 10 digits",
                  },
                })}
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 10);
                }}
              />
              {errors.mobileNumber && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.mobileNumber.message}
                </p>
              )}
            </div>
            <div className="col-span-1">
              <label className="block text-sm font-medium text-primaryTextColor">
                Email ID
              </label>
              <input
                type="email"
                placeholder="Email Id"
                className={`mt-1 block w-full border ${
                  errors.email ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                {...register("email")}
              />
            </div>

            <div className="col-span-1">
              <label className="block text-sm font-medium text-primaryTextColor">
                Source
              </label>
              <select
                className={`mt-1 block w-full border ${
                  errors.source ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                {...register("source")}
              >
                <option value="">Select Source</option>
                <option value="Google">Google</option>
                <option value="Social Media">Social Media</option>
                <option value="Referral">Referral</option>
                <option value="Walk In">Walk In</option>
                <option value="Institute Referral">Institute Referral</option>
                <option value="Others">Others</option>
              </select>
            </div>

            <div className="col-span-1 relative">
              <label className="block text-sm font-medium text-primaryTextColor">
                Joining Date <span className="text-red-500">*</span>
              </label>
              <input
                type="date"
                placeholder="dd/mm/yyyy"
                min={new Date().toISOString().split("T")[0]}
                className={`mt-1 block w-full border ${
                  errors.joiningDate ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                {...register("joiningDate", {
                  required: true,
                  validate: (value) => {
                    const today = new Date();
                    const selectedDate = new Date(value);
                    if (selectedDate < today.setHours(0, 0, 0, 0)) {
                      return "Joining date cannot be in the past";
                    }
                    return true;
                  },
                })}
                onBlur={(e) => {
                  const value = e.target.value;

                  if (value) {
                    const selectedDate = new Date(value);
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);

                    if (selectedDate < today) {
                      toast.error("Joining date cannot be in the past");
                      setValue("joiningDate", "");
                      e.target.value = "";
                    }
                  }
                }}
              />
            </div>
            <div className="col-span-1">
              <label className="block text-sm font-medium text-primaryTextColor">
                Booking Amount <span className="text-red-500">*</span>
              </label>
              <input
                type="number"
                placeholder="₹ Enter The Booking Amount"
                className={`mt-1 block w-full border ${
                  errors.bookingAmount ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                {...register("bookingAmount", { required: true, min: 0 })}
              />
            </div>

            <div className="col-span-1">
              <label className="block text-sm font-medium text-primaryTextColor">
                Building Name <span className="text-red-500">*</span>
              </label>
              <select
                className={`mt-1 block w-full border ${
                  errors.hostelName ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                {...register("hostelName", { required: true })}
                onChange={(e) => {
                  getFloors(e.target.value);
                  setBuildingId(e.target.value);
                }}
              >
                <option value="">Select Building</option>
                {building.map((item) => (
                  <option key={item._id} value={item._id}>
                    {item.nameBuilding}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-span-1">
              <label className="block text-sm font-medium text-primaryTextColor">
                Floor No <span className="text-red-500">*</span>
              </label>
              <select
                className={`mt-1 block w-full border ${
                  errors.floorNo ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                {...register("floorNo", { required: true })}
                onChange={(e) => getConfiguredRoomByBuilding(e.target.value)}
              >
                <option value="">Select a floor</option>
                {floor.map((f, index) => (
                  <option key={index} value={f.floorNumber}>
                    Floor-{f.floorNumber}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-span-1">
              <label className="block text-sm font-medium text-primaryTextColor">
                Available Rooms <span className="text-red-500">*</span>
              </label>
              <select
                className={`mt-1 block w-full border ${
                  errors.roomId ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                {...register("roomId", { required: true })}
                onChange={(e) => {
                  handleBed(e.target.value);
                  setBedValue("");

                  // Logs the selected room object
                }}
              >
                <option value="">Select Room Number </option>
                {rooms.map((room, index) => (
                  <option key={index} value={String(room._id)}>
                    R-F{floorNumber}
                    {String(room.roomNumber).padStart(3, "0")}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-span-1">
              <label className="block text-sm font-medium text-primaryTextColor">
                Bed No. <span className="text-red-500">*</span>
              </label>
              <select
                value={bedValue}
                onInput={(e) => setBedValue(e.target.value)}
                className={`mt-1 block w-full border ${
                  errors.bedNumber ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                {...register("bedId", { required: true })}
              >
                <option value="">Select Bed Number</option>
                {bed
                  .sort((a, b) => {
                    const numA = parseInt(a.bedNumber.slice(1)); // Extract the number after 'B'
                    const numB = parseInt(b.bedNumber.slice(1)); // Extract the number after 'B'
                    return numA - numB; // Compare the numbers
                  })
                  .map((bed, index) => (
                    <option
                      key={index}
                      value={bed._id}
                      disabled={bed.isOccupied}
                      style={{
                        color: bed.isOccupied ? "green" : "black",
                      }}
                    >
                      {bed.bedNumber} {bed.isOccupied && "(Occupied)"}
                    </option>
                  ))}
              </select>
            </div>

            <div className="col-span-2">
              <label className="block text-sm font-medium text-primaryTextColor">
                Comments
              </label>
              <textarea
                type="text"
                placeholder="Write Your Comments"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                {...register("comments")}
              />
            </div>
          </div>

          <div className="flex justify-between gap-6 mt-6 tracking-wide">
            <button
              onClick={() => setBookingModal(false)}
              type="button"
              className="bg-white w-full border hover:bg-secondaryTextColor px-4 py-2 rounded-md"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-primaryBtnColor hover:bg-primaryBtnHoverColor w-full text-white px-4 py-2 rounded-md"
            >
              {"Submit"}
            </button>
          </div>
        </form>
      </div>

      {load && (
        <div className="fixed inset-0 h-screen w-screen flex items-center justify-center bg-black bg-opacity-50">
          <span class="loader"></span>
        </div>
      )}
    </div>
  );
};

export default CreateBooking;
